
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/torches/[torch]",
      function () {
        return require("private-next-pages/[locale]/torches/[torch]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/torches/[torch]"])
      });
    }
  